import { LegalLayout } from './LegalLayout'
import { COMPANY, ADDRESS_INCOMPLETE, formattedAddress } from './legalConfig'

export function Contact() {
  return (
    <LegalLayout title="Contact" updated={false}>
      {import.meta.env.DEV && ADDRESS_INCOMPLETE && (
        <p className="legal__devwarn">
          Dev only notice: the registered address in legalConfig.ts is still a placeholder. Fill it
          in before this page is used for Apple Developer enrolment.
        </p>
      )}

      <p className="legal__lede">
        {COMPANY.tradingName} is built and operated by {COMPANY.legalName}. We read everything sent
        to the address below and aim to reply within two business days.
      </p>

      <div className="legal__contact">
        <div className="legal__contact-block">
          <h2>Email</h2>
          <p>
            <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
          </p>
          <p className="legal__muted">
            Support, billing, press, and privacy requests all reach us here.
          </p>
        </div>

        <div className="legal__contact-block">
          <h2>Registered office</h2>
          <address className="legal__address">
            <strong>{COMPANY.legalName}</strong>
            {/* Publishing a half filled address reads as a broken or fake site,
                which is worse than showing none. Until the real address is set
                in legalConfig.ts, show only what is true. */}
            {ADDRESS_INCOMPLETE ? (
              <>
                {'\n'}
                {COMPANY.address.region}, {COMPANY.address.country}
              </>
            ) : (
              <>
                {'\n'}
                {formattedAddress()}
              </>
            )}
          </address>
          {ADDRESS_INCOMPLETE && (
            <p className="legal__muted" style={{ marginTop: 10 }}>
              Postal address available on request by email.
            </p>
          )}
        </div>
      </div>

      <h2>Existing customers</h2>
      <p>
        If you already have an account, the fastest route is to email us from the address your
        account uses so we can find you quickly. Include your organisation name and, if it relates
        to a specific brief, the date of that brief.
      </p>

      <h2>Interested in GoGrov</h2>
      <p>
        GoGrov is currently onboarding publishers by invitation while we work closely with our
        first partners. If you cover a town and want to be part of that, email us and tell us where
        you publish and what you cover.
      </p>

      <h2>Privacy and data requests</h2>
      <p>
        To request a copy of your data, a correction, or deletion, email us with the subject line
        "Data request". See our <a href="/privacy">Privacy Policy</a> for what we hold and how long
        we keep it.
      </p>
    </LegalLayout>
  )
}
